import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

const defaultDriverState = {
  isOnDuty: false,
  dutyLastUpdated: null,
  nextAvailableAt: null,
  availabilityLastUpdated: null,
  riderQueue: 0,
};

// Driver store
export const useDriverStore = create(
  devtools(
    persist(
      (set, get) => ({
        ...defaultDriverState,

      // Driver duty status with timestamp (bundled object)
      getDriverDutyStatus: () => ({
          isOnDuty: get().isOnDuty,
          lastUpdated: get().dutyLastUpdated,
        }),

      // Update duty status from query or subscription
      updateDriverDutyStatus: (isOnDuty) =>
          set({
            isOnDuty,
            dutyLastUpdated: new Date().toISOString(),
          }),

      // Driver availability status with timestamp (bundled object)
      getDriverAvailability: () => ({
          time: get().nextAvailableAt,
          lastUpdated: get().availabilityLastUpdated,
        }),

      // Update driver availability from query or subscription
      updateDriverAvailability: (time) =>
          set({
            nextAvailableAt: time,
            availabilityLastUpdated: new Date().toISOString(),
          }),

      // Get driver rider queue
      getDriverRiderQueue: () => ({
          riderQueue: get().riderQueue,
        }),

      // Update driver rider queue
      updateDriverRiderQueue: (queueCount) =>
          set({ riderQueue: queueCount }),

      // Increment/decrement queue count (for accepting/completing rides)
      adjustDriverRiderQueue: (adjustment) =>
          set((state) => ({
            riderQueue: Math.max(0, state.riderQueue + adjustment),
          })),

      // Reset
        resetDriverState: () => set(defaultDriverState),
    }),
    {
        name: 'driver-storage',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    { name: 'Driver Store' }
  )
);
